import {DocumentReminderSettingsEditBackendData, FormFields} from './types';

const getInitialFormField = ({
    data,
}: DocumentReminderSettingsEditBackendData['data']): FormFields => {
    return {
        attachmentTypes: [...data.attachmentTypes],
        isActive: data.isActive,
        secureSendMessageEn: data.secureSendMessageEn,
        secureSendMessageJa: data.secureSendMessageJa,
        secureSendSubjectEn: data.secureSendSubjectEn,
        secureSendSubjectJa: data.secureSendSubjectJa,
        timing: data.timing,
    };
};

export default getInitialFormField;
